module.exports = __webpack_public_path__ + "img/output.bc9b3e81.png";